import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 24,
    width: "100%",
    padding: 24,
    boxSizing: "border-box",
    borderRadius: 6,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    direction: "rtl",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: 24,
    margin: 0,
    padding: 0,
    direction: "rtl",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    minWidth: 0,
    direction: "rtl",
  },
  fieldWide: {
    gridColumn: "span 2",
  },
  label: {
    fontFamily: theme.typography.fontFamily,
    fontSize: 12,
    fontWeight: 500,
    lineHeight: "18px",
    color: theme.palette.secondary.main,
    textAlign: "right",
    margin: 0,
  },
  input: {
    width: "100%",
    margin: 0,
    direction: "rtl",
    opacity: 1,
    "& .MuiOutlinedInput-root": {
      height: 48,
      minHeight: 48,
      maxHeight: 48,
      boxSizing: "border-box",
      borderRadius: 4,
      gap: 10,
      opacity: 1,
      backgroundColor: theme.palette.background.paper,
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      fontWeight: 400,
      color: theme.palette.secondary.main,
      direction: "rtl",
      "& fieldset": {
        borderColor: theme.palette.divider,
        borderWidth: 1,
      },
      "&:hover fieldset": { borderColor: theme.palette.divider },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.divider,
        borderWidth: 1,
      },
      "&.Mui-disabled fieldset": {
        borderColor: theme.palette.divider,
      },
    },
    "& .MuiOutlinedInput-input": {
      height: "100%",
      boxSizing: "border-box",
      paddingTop: "12px !important",
      paddingRight: "16px !important",
      paddingBottom: "12px !important",
      paddingLeft: "8px !important",
      textAlign: "right",
      direction: "rtl",
      border: "none",
      outline: "none",
      boxShadow: "none",
      "&::placeholder": {
        color: theme.palette.text.primary,
        opacity: 1,
        textAlign: "right",
      },
      "&:-webkit-autofill": {
        WebkitBoxShadow: `0 0 0 100px ${theme.palette.background.paper} inset`,
        WebkitTextFillColor: theme.palette.secondary.main,
        caretColor: theme.palette.secondary.main,
        borderRadius: 4,
      },
    },
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      height: 48,
      minHeight: "48px !important",
      maxHeight: 48,
      boxSizing: "border-box",
      paddingTop: "12px !important",
      paddingRight: "16px !important",
      paddingBottom: "12px !important",
      paddingLeft: "32px !important",
      textAlign: "right",
      direction: "rtl",
    },
    "& .MuiSelect-icon": {
      right: "auto",
      left: 8,
      top: "50%",
      transform: "translateY(-50%)",
      position: "absolute",
    },
  },
  checks: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: 10,
    direction: "rtl",
  },
  checkCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 10,
    margin: 0,
    height: 48,
    minHeight: 48,
    opacity: 1,
    paddingTop: 12,
    paddingRight: 16,
    paddingBottom: 12,
    paddingLeft: 8,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    boxSizing: "border-box",
    cursor: "pointer",
    direction: "rtl",
    "& .MuiCheckbox-root": { padding: 0, flexShrink: 0 },
  },
  checkLabel: {
    fontFamily: theme.typography.fontFamily,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: "21px",
    color: theme.palette.secondary.main,
    textAlign: "right",
  },
  notesField: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    minWidth: 0,
    opacity: 1,
    direction: "rtl",
  },
  notesInput: {
    width: "100%",
    margin: 0,
    direction: "rtl",
    opacity: 1,
    "& .MuiOutlinedInput-root": {
      height: 107,
      minHeight: 107,
      maxHeight: 107,
      boxSizing: "border-box",
      borderRadius: 4,
      gap: 10,
      opacity: 1,
      alignItems: "flex-start",
      paddingTop: 12,
      paddingRight: 16,
      paddingBottom: 12,
      paddingLeft: 8,
      backgroundColor: theme.palette.background.paper,
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      fontWeight: 400,
      color: theme.palette.secondary.main,
      direction: "rtl",
      "& fieldset": {
        borderColor: theme.palette.divider,
        borderWidth: 1,
      },
      "&:hover fieldset": { borderColor: theme.palette.divider },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.divider,
        borderWidth: 1,
      },
      "&.Mui-disabled fieldset": {
        borderColor: theme.palette.divider,
      },
    },
    "& .MuiOutlinedInput-input": {
      height: "auto !important",
      minHeight: 0,
      boxSizing: "border-box",
      padding: "0 !important",
      textAlign: "right",
      direction: "rtl",
      resize: "none",
      overflow: "auto",
      border: "none",
      outline: "none",
      boxShadow: "none",
      "&::placeholder": {
        color: theme.palette.text.primary,
        opacity: 1,
        textAlign: "right",
      },
    },
  },
}));
